/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Order_FilteredInputs */

const id_tld_pricing_order_filtered = /** @type {(inputs: Tld_Pricing_Order_FilteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosongkan pencarian dan saringan untuk mengubah urutan.`)
};

const en_tld_pricing_order_filtered = /** @type {(inputs: Tld_Pricing_Order_FilteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear the search and the filters to change the order.`)
};

/**
* | output |
* | --- |
* | "Clear the search and the filters to change the order." |
*
* @param {Tld_Pricing_Order_FilteredInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_order_filtered = /** @type {((inputs?: Tld_Pricing_Order_FilteredInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Order_FilteredInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_order_filtered(inputs)
	return id_tld_pricing_order_filtered(inputs)
});